import { action, observable, runInAction } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import { partnerServiceController } from './partnerServiceController';
import {
  PartnerServicePrioritiesRequestInterface,
  PartnerServicePrioritiesUpdateInterface,
  PartnerServicePrioritiesItemInterface,
} from './partnerServices';

export interface PartnerServicesStore {
  partnerServicePriorities: PartnerServicePrioritiesItemInterface[],
  partnerServicePrioritiesRequest: PartnerServicePrioritiesRequestInterface,

  error: ErrorInterface,
}

const initialValues: PartnerServicesStore = {
  partnerServicePriorities: [],
  partnerServicePrioritiesRequest: null,

  error: null,
};

export const partnerServicesStore = observable(initialValues);

export const partnerServicesActions = {

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      partnerServicesStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      throw errorData;
    }
  }),

  async clearError() {
    partnerServicesStore.error = null;
  },

  async getPartnerPriorities(request: PartnerServicePrioritiesRequestInterface) {
    if (request.fiasId && request.serviceId) {
      try {
        partnerServicesStore.partnerServicePrioritiesRequest = request;
        const response = await partnerServiceController.getPartnerPriorities(request);
        runInAction(() => {
          const x: PartnerServicePrioritiesItemInterface[] = response.data ?? [];
          partnerServicesStore.partnerServicePriorities = x.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
        });
      } catch (err) {
        this.handleError(err);
      }
    } else {
      partnerServicesActions.clearPartnerServicePriorities();
    }
  },

  async updatePartnerPriorities(data: PartnerServicePrioritiesUpdateInterface) {
    try {
      await partnerServiceController.updatePartnerPriorities(data);
    } catch (err) {
      this.handleError(err);
    }
  },

  clearPartnerPrioritiesUpdated: action(() => {
    partnerServicesStore.partnerServicePriorities = partnerServicesStore.partnerServicePriorities.map((v) => {
      return { ...v, updated: false };
    });
  }),

  async savePartnerPriorities() {
    const promiseUpdate = partnerServicesStore.partnerServicePriorities
      .filter((v) => v.updated)
      .map((v) => partnerServicesActions.updatePartnerPriorities({
        id: v.id,
        priority: v.priority,
      }));
    await Promise.all(promiseUpdate);
    partnerServicesActions.clearPartnerPrioritiesUpdated();
  },

  async setNewPriority(id:number, priority: number) {
    const x = [...partnerServicesStore.partnerServicePriorities];
    runInAction(() => {
      x.find((v) => v.id === id).priority = priority;
      x.find((v) => v.id === id).updated = true;
      partnerServicesStore.partnerServicePriorities = [...x];
    });
  },

  clearPartnerServicePriorities: action(() => {
    partnerServicesStore.partnerServicePriorities = [];
    partnerServicesStore.partnerServicePrioritiesRequest = null;
    partnerServicesStore.error = null;
  }),

};
